import(/* webpackMode: "eager", webpackExports: ["PartnerLoginPage"] */ "/app/apps/platform-web/components/partner-app/PartnerLoginPage.tsx");
